import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { STEPS, STEPS_CRYPTO_PAYMENT } from "../utils/Constants";

const devtoolsInNonProd = (process.env.NODE_ENV === 'production' ? (fn) => fn : devtools)

const useStore = create(devtoolsInNonProd((set) => ({
  //States
  lang: null,
  catalogLang: null,
  receiveData: null,
  //ejemplo de recibo
  // receiveData: {
  //   cryptoAmount: 9.99,
  //   amountUsd: 10,
  //   date: new Date(),
  //   method: "Crypto",
  //   network: "Ethereum",
  //   coin: "ETH",
  //   address: "0xb4be174ff2af0d320c451c49a781ab6fa6c010fe",
  // },
  user: null,
  maxAmountZinli: null,
  paymentInfoZinli: null,
  currentStepZinli: { ref: STEPS.LOADING_DATA, data: {} },
  currentStepCrypto: { ref: STEPS_CRYPTO_PAYMENT.LOADING_DATA, data: {} },
  currencySelected: null,
  networkSelected: null,
  addressToPay: "",
  hideTitleCrypto: false,
  coins: null,
  networks: null,
  errorTimer: null,

  //Setters
  setCatalogLang: (data) => {
    set((state) => ({
      catalogLang: data
    }));
  },
  setLang: (data) => {
    set((state) => ({
      lang: data
    }));
  },
  setReceiveData: (data) => {
    set((state) => ({
      receiveData: data
    }));
  },
  setUserData: (data) => {
    set((state) => ({
      user: data
    }));
  },
  setMaxAmountZinli: (data) => {
    set((state) => ({
      maxAmountZinli: data
    }));
  },
  setPaymentInfoZinli: (data) => {
    set((state) => ({
      paymentInfoZinli: data
    }));
  },
  setCurrentStepZinli: (step) => {
    set((state) => ({
      currentStepZinli: { ...state.currentStepZinli, ...step }
    }));
  },
  setCurrencySelected: (currency) => {
    set((state) => ({
      currencySelected: currency
    }));
  },
  setNetworkSelected: (network) => {
    set((state) => ({
      networkSelected: network
    }));
  },
  setAddressToPay: (address) => {
    set((state) => ({
      addressToPay: address
    }));
  },
  setCurrentStepCrypto: (step) => {
    set((state) => ({
      currentStepCrypto: { ...state.currentStepCrypto, ...step }
    }));
  },
  setHideTitleCrypto: (step) => {
    set((state) => ({
      hideTitleCrypto: step
    }));
  },
  setCoins: (coins) => {
    set((state) => ({
      coins: coins
    }));
  },
  setNetworks: (networks) => {
    set((state) => ({
      networks: networks
    }));
  },
  setErrorTimer: (error) => {
    set((state) => ({
      errorTimer: error
    }));
  },
})));

export default useStore;
